import React from "react";
import { Link } from "react-router-dom";

const FooterOne = () => {
  return (
    <footer className="footer py-80 bg-gradient-to-br from-neutral-900 to-neutral-800 position-relative overflow-hidden">
      {/* Background Pattern */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
        <div className="position-absolute" style={{
          top: '20%',
          right: '10%',
          width: '200px',
          height: '200px',
          background: 'radial-gradient(circle, rgba(41, 158, 96, 0.1) 0%, transparent 70%)',
          borderRadius: '50%'
        }}></div>
        <div className="position-absolute" style={{
          bottom: '30%',
          left: '5%',
          width: '150px',
          height: '150px',
          background: 'radial-gradient(circle, rgba(255, 193, 7, 0.08) 0%, transparent 70%)',
          borderRadius: '50%'
        }}></div>
      </div>

      <div className="container container-lg position-relative" style={{ zIndex: 1 }}>
        <div className="row g-40">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="footer-company">
              <div className="footer-logo mb-24">
                <Link to="/" className="d-inline-block">
                  <img 
                    src="/assets/images/logo/logo.png" 
                    alt="Gümüş Pestil" 
                    style={{ 
                      maxHeight: '60px', 
                      width: 'auto',
                      filter: 'brightness(0) invert(1)'
                    }} 
                  />
                </Link>
              </div>
              <p className="text-gray-300 mb-32" style={{ 
                fontSize: 'clamp(14px, 2.5vw, 16px)', 
                lineHeight: '1.6' 
              }}>
                Gümüş Pestil, Türkiye'nin en modern ve en güvenilir pestil firmasıdır. 
                Geleneksel lezzetleri modern yaşamla buluşturuyoruz.
              </p>
              
              {/* Contact Info */}
              <div className="contact-info">
                <div className="contact-item d-flex align-items-center gap-16 mb-20">
                  <div className="flex-shrink-0">
                    <div className="w-40 h-40 rounded-circle bg-main-600 d-flex align-items-center justify-content-center">
                      <i className="ph-fill ph-map-pin text-white" style={{ fontSize: '16px' }}></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="text-gray-300 mb-0" style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}>
                      Gümüşhane-Trabzon yolu üzeri 13 km,<br />
                      29100 Gümüşhane Merkez/Gümüşhane
                    </p>
                  </div>
                </div>
                
                <div className="contact-item d-flex align-items-center gap-16 mb-20">
                  <div className="flex-shrink-0">
                    <div className="w-40 h-40 rounded-circle bg-main-600 d-flex align-items-center justify-content-center">
                      <i className="ph-fill ph-phone-call text-white" style={{ fontSize: '16px' }}></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <Link
                      to="tel:+905394838998"
                      className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                      style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                    >
                      +90 (539) 483 89 98
                    </Link>
                  </div>
                </div>
                
                <div className="contact-item d-flex align-items-center gap-16">
                  <div className="flex-shrink-0">
                    <div className="w-40 h-40 rounded-circle bg-main-600 d-flex align-items-center justify-content-center">
                      <i className="ph-fill ph-envelope text-white" style={{ fontSize: '16px' }}></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <Link
                      to="mailto:destek@gumuspestil.com"
                      className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                      style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                    >
                      destek@gumuspestil.com
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6 col-6">
            <div className="footer-links">
              <h6 className="footer-title text-white mb-24 fw-bold" style={{ fontSize: 'clamp(16px, 3vw, 18px)' }}>
                Bilgi
              </h6>
              <ul className="footer-menu list-unstyled">
                <li className="mb-12">
                  <Link 
                    to="/" 
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Anasayfa
                  </Link>
                </li>
                <li className="mb-12">
                  <Link 
                    to="/shop" 
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Ürünler
                  </Link>
                </li>
                <li className="mb-12">
                  <Link
                    to="/kendin-sec"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Kendin Seç
                  </Link>
                </li>
                <li className="mb-12">
                  <Link 
                    to="/blog" 
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Blog
                  </Link>
                </li>
                <li className="mb-12">
                  <Link
                    to="/sozlesme"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Sözleşme
                  </Link>
                </li>
                <li>
                  <Link
                    to="/iade-politikasi"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    İade Politikası
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Account Links */}
          <div className="col-lg-2 col-md-6 col-6">
            <div className="footer-links">
              <h6 className="footer-title text-white mb-24 fw-bold" style={{ fontSize: 'clamp(16px, 3vw, 18px)' }}>
                Hesabım
              </h6>
              <ul className="footer-menu list-unstyled">
                <li className="mb-12">
                  <Link
                    to="/profile"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Profilim
                  </Link>
                </li>
                <li className="mb-12">
                  <Link
                    to="/addresses"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Adreslerim
                  </Link>
                </li>
                <li className="mb-12">
                  <Link
                    to="/orders"
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Siparişlerim
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/cart" 
                    className="text-gray-300 hover-text-white transition-2 text-decoration-none"
                    style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}
                  >
                    Sepetim
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Newsletter & Social */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="footer-newsletter">
              <h6 className="footer-title text-white mb-24 fw-bold" style={{ fontSize: 'clamp(16px, 3vw, 18px)' }}>
                Bülten
              </h6>
              <p className="text-gray-300 mb-24" style={{ fontSize: 'clamp(13px, 2.5vw, 14px)' }}>
                Yeni ürünler ve özel kampanyalardan haberdar olmak için bültenimize abone olun.
              </p>
              
              <div className="newsletter-form mb-32">
                <div className="input-group">
                  <input 
                    type="email" 
                    className="form-control bg-neutral-700 border-neutral-600 text-white rounded-start-pill" 
                    placeholder="E-posta adresiniz"
                    style={{ 
                      fontSize: 'clamp(13px, 2.5vw, 14px)',
                      padding: '12px 20px'
                    }}
                  />
                  <button 
                    className="btn btn-main rounded-end-pill px-24"
                    style={{ 
                      fontSize: 'clamp(13px, 2.5vw, 14px)',
                      fontWeight: '600'
                    }}
                  >
                    Abone Ol
                  </button>
                </div>
              </div>

              {/* Social Media */}
              <div className="social-links">
                <h6 className="text-white mb-16 fw-semibold" style={{ fontSize: 'clamp(14px, 2.5vw, 16px)' }}>
                  Bizi Takip Edin
                </h6>
                <div className="d-flex gap-12">
                  <a 
                    href="https://www.facebook.com/gumuspestil29" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-40 h-40 rounded-circle bg-neutral-700 d-flex align-items-center justify-content-center text-white hover-bg-main-600 transition-2"
                    style={{ fontSize: '16px' }}
                  >
                    <i className="ph-fill ph-facebook-logo"></i>
                  </a>
                  <a 
                    href="https://www.instagram.com/gumuspestil/" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-40 h-40 rounded-circle bg-neutral-700 d-flex align-items-center justify-content-center text-white hover-bg-main-600 transition-2"
                    style={{ fontSize: '16px' }}
                  >
                    <i className="ph-fill ph-instagram-logo"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
